import e from"style-inject";var l={singleValue:"singleValue-module_singleValue__HLuE-"};e(".singleValue-module_singleValue__HLuE- {\n  padding-inline: var(--spacing-xs);\n}");export{l as default};
